import PropTypes from 'prop-types'
import React, { useState, useEffect } from 'react'
import { withTheme } from 'styled-components'

import ApiErrorWidget from './ApiErrorWidget.jsx'
import { FlightsList } from './FlightsList.jsx'
import { Loading } from './Loading.jsx'
import NoFlightResultsWidget from './NoFlightResultsWidget.jsx'

export const ListItemType = {
  SECTION_TITLE: 1,
  FLIGHT: 2
}

export const FlightSearch = withTheme(({
  widgetState,
  onFlightClick,
  isDesktop,
  T
}) => {
  const [state, setState] = useState(widgetState.getState())
  useEffect(() => widgetState.addCallback(setState), [widgetState])

  const { loading, flightItems, noResultsError, apiError } = state

  if (loading) return <Loading />

  if (apiError) return <ApiErrorWidget isDesktop={isDesktop} T={T} />

  if (noResultsError) return <NoFlightResultsWidget isDesktop={isDesktop} T={T} />

  return <FlightsList
    items={flightItems}
    onFlightClick={onFlightClick}
    T={T}
  />
})

FlightSearch.propTypes = {
  widgetState: PropTypes.object.isRequired,
  T: PropTypes.func.isRequired,
  onSearchTermChange: PropTypes.func,
  onFlightClick: PropTypes.func,
  onFlightTypeSwitched: PropTypes.func
}

FlightSearch.defaultProps = {
  onSearchTermChange: () => { },
  onFlightClick: () => { },
  onFlightTypeSwitched: () => { }
}
